// extracted by mini-css-extract-plugin
export default {"triggerButton":"triggerButton---N_p1F"};